(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
(function(){
  const rotators = document.querySelectorAll('.announce__rotator');
  rotators.forEach(r => {
    const items = r.querySelectorAll('.announce__item');
    if (items.length < 2) return;
    const speed = parseInt(r.dataset.rotateSpeed || '5', 10) * 1000;
    let i = 0;
    setInterval(() => {
      items[i].classList.remove('is-active');
      i = (i + 1) % items.length;
      items[i].classList.add('is-active');
    }, speed);
  });
})();

  } catch(e) { console.error(e); }
})();
})();
